/**
 * @file readOnlyActions.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-09-02
 * @modified 2026-09-02
 */

/** Shown on every action a view-only account cannot use. */
export const READ_ONLY_TITLE =
  'Your account has view-only access and cannot change records';

/**
 * Default-DENY an action list for a view-only account.
 *
 * Every action is disabled unless it opts in with `readSafe: true`. That
 * direction is deliberate and mirrors middleware/readOnly.js on the server: an
 * allow-by-default rule has to be remembered at each of two hundred call sites,
 * and the two-hundred-and-first will not have it. Here, a row action added next
 * year is inert for a rep with nobody having to think about it — the failure
 * mode is a read that needs marking, which is visible and harmless, rather than
 * a write that stayed live.
 *
 * `readSafe` means the action only shows what the caller can already see: View,
 * and View history. Anything that sends, prints, exports, generates or pushes is
 * NOT read-safe — the server refuses those for a read-only badge, so leaving
 * them clickable only produces a 403 toast.
 *
 * Disabled, never hidden — the project's rule that a row's action count must not
 * change between row types applies just as much between user types.
 */
export function applyReadOnly(actions, readOnly) {
  if (!readOnly || !Array.isArray(actions)) return actions;
  return actions.map(a => {
    if (!a || a.readSafe) return a;
    return {
      ...a,
      disabled: true,
      title: a.title ? `${a.title} — ${READ_ONLY_TITLE}` : READ_ONLY_TITLE,
      onClick: undefined
    };
  });
}
